module.exports = __webpack_public_path__ + "static/media/location-maps-letter-i-arrow.ae32941a.png";